<template>

<div class="container-fluid body no-gutters p-0">
  <div class="container">
    <div class="row  paddt10" v-if="$parent.platform == 'web'" :data-w="$parent.platform">
          <div class="col-md-12 col-sm-12 hidden-xs ">
              <div class="row justify-content-center">
<!--                        <div class="col-sm-2 col-md-2 text-center avon">-->
<!--                            <h2 class="mdisponible">{{$parent.lang.availableOn}}</h2> </div>-->
                  <div class="col-sm-2 col-md-2 text-center avon">
                      <a rel="noopener" href="https://itunes.apple.com/us/app/flixlatino/id1113757930?mt=8" target="_blank">
                        <img alt="App Store" width="127" height="43" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/img/appstore.png')" >
                      </a>
                  </div>
                  <div class="col-sm-2 col-md-2 text-center avon">
                      <a rel="noopener" href="https://play.google.com/store/apps/details?id=com.trespixels.flixlatino&amp;hl=en" target="_blank">
                        <img alt="Google Play" width="127" height="43" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/img/googleplay.png')" >
                      </a>
                  </div>
                  <div class="col-sm-2 col-md-2 text-center avon">
                      <a rel="noopener" href="https://channelstore.roku.com/details/131958/flixlatinogo" target="_blank">
                        <img alt="Roku Store" width="127" height="43" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/img/rokustore.png')" >
                      </a>
                  </div>
                  <div class="col-sm-2 col-md-2 text-center avon">
                    <img alt="Samsung App" width="127" height="43" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/2019/img/samsung-logo.png')" >
                  </div>
                  <div class="col-sm-2 col-md-2 text-center avon">
                      <a rel="noopener" target="_blank" href="https://www.amazon.com/SOMOS-Next-LLC-FlixLatino/dp/B07RBZ6QYH/">
                        <img alt="Amazon Fire" width="127" height="43" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" v-lazyload :data-src="$parent.png('https://flxassets.s3-accelerate.amazonaws.com/img/amazonfire.png')" >
                      </a>
                  </div>
              </div>
          </div>
          <div class="col-sm-4 col-md-4 hidden-sm hidden-xs"> </div>
    </div>
  </div>
</div>
</template>


<script>




export default {
  name: 'flixBody',
  components: {
  },
  data(){ return {

    }
  },
  created: function () {
    // this.lang = lang.es;
    // this.isIos = lang.isIos;

    
    
  },
  updated: function(){
    // this.profiling();

  },
  computed:{

  },
  
  methods:{


    

  }
  
}
</script>

<style lang="css">
.avon > a > img{
  width: 80%;
  height: auto;
}
</style>